import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconFullscreenExit$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconFullscreenExit extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '1f71b1e58760429dc534b9f74d1f94f775061e9d', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '8cf784bb99a3e5821b3045c70f2fcd46e4ce13f2', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'bec1583e78bef87309c1519aa34049d65828f1b5', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M7.5 4.5v3h-5A.5.5 0 0 0 2 8v.5a.5.5 0 0 0 .5.5h6a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 0-.5-.5H8a.5.5 0 0 0-.5.5m0 10h-5A.5.5 0 0 1 2 14v-.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5H8a.5.5 0 0 1-.5-.5zm7 0v3a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5zm0-7h5a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5h-6a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .5-.5h.5a.5.5 0 0 1 .5.5z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-fullscreen-exit", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-fullscreen-exit"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-fullscreen-exit":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconFullscreenExit$1);
            }
            break;
    } });
}

const CosmosIconFullscreenExit = CosmosIconFullscreenExit$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconFullscreenExit, defineCustomElement };
